/* src/app/index/site-create/site-create-component.scss */
#site-create-map {
  height: 50vh;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}
/*# sourceMappingURL=site-create-component.css.map */
